/* eslint-disable no-useless-catch */
import { serialize } from '../utils';
import { entityService } from './services';
// #endregion Local Imports

const pathname = '/customers';

export const CustomerApi = {
  filter: async (option: any) => {
    let url = `${pathname}/filter`;

    const { entityIDs, customerGroupIDs, ...newOption } = option;
    const query = serialize(newOption);
    url += query;

    try {
      const response = await entityService.post(url, {
        entityIDs,
        customerGroupIDs,
      });

      return response;
    } catch (error) {
      throw error;
    }
  },

  filterZNS: async (option: any) => {
    let url = `${pathname}/ZNS/filter`;

    const { entityIDs, ...newOption } = option;
    const query = serialize(newOption);
    url += query;

    try {
      const response = await entityService.post(url, { entityIDs });

      return response;
    } catch (error) {
      throw error;
    }
  },

  findCustomerInChainEntities: async (id: string) => {
    const url = `${pathname}/${id}/chain-entities`;

    try {
      const response = await entityService.get(url);
      return response;
    } catch (error) {
      throw error;
    }
  },

  findCustomerGroupOfCustomer: async (id: string) => {
    const url = `${pathname}/${id}/customer-group`;

    try {
      const response = await entityService.get(url);
      return response;
    } catch (error) {
      throw error;
    }
  },

  create: async (body: any) => {
    try {
      const response = await entityService.post(pathname, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  sendZNS: async (body: any) => {
    try {
      const url = `${pathname}/zns`;
      const response = await entityService.post(url, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  findOne: async (id: string) => {
    const url = `${pathname}/${id}`;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  findCustomerForCRM: async (id: string) => {
    const url = `${pathname}/find-customer-for-crm/${id}`;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  findUserConnectCustomer: async (id: string) => {
    const url = `${pathname}/connect/${id}`;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  connectUserAccount: async (id: string) => {
    const url = `${pathname}/connect/${id}`;

    try {
      const response = await entityService.patch(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  findPurchaseInformation: async (id: string) => {
    const url = `${pathname}/purchase-info/${id}`;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  createUserForCustomer: async (body: any) => {
    try {
      const response = await entityService.post(
        `${pathname}/connect-new-user`,
        body
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  update: async (id: string, body: any = {}) => {
    const url = `${pathname}/${id}`;

    try {
      const response = await entityService.patch(url, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  updateStatus: async (id: string, body: any = {}) => {
    const url = `${pathname}/${id}/status`;

    try {
      const response = await entityService.patch(url, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  delete: async (id: string) => {
    const url = `${pathname}/${id}`;

    try {
      const response = await entityService.delete(url);
      return response;
    } catch (error) {
      throw error;
    }
  },

  checkDuplicate: async (option?: CheckDuplicateCustomerCodeQuery) => {
    let url = `${pathname}/check-duplicate`;
    const query = serialize(option || {});
    url += query;
    try {
      const response = await entityService.get(url);
      return response;
    } catch (error) {
      throw error;
    }
  },

  generateCode: async (option: GenerateCustomerCodeQuery) => {
    let url = `${pathname}/generate-code`;
    const query = serialize(option);
    url += query;
    try {
      const response = await entityService.get(url);
      return response;
    } catch (error) {
      throw error;
    }
  },

  deleteMulti: async (ids: string[]) => {
    const url = `${pathname}/multi/delete`;
    try {
      const response = await entityService.patch(url, { customerIDs: ids });
      return response;
    } catch (error) {
      throw error;
    }
  },

  exportCustomer: async (ids?: string[]) => {
    const url = `${pathname}/export`;

    try {
      const response = await entityService.post(url, {
        customerIDs: ids || [],
      });
      return response;
    } catch (error) {
      throw error;
    }
  },
};

export interface CheckDuplicateCustomerCodeQuery {
  code: string;
  entityID?: string;
}

export interface GenerateCustomerCodeQuery {
  entityID?: string;
}

export interface FilterEmployeeOptions {
  page?: number;
  take?: number;
  order?: any;
  reserved?: boolean;
  name?: string;
  entityIDs?: string;
  status?: number;
  type?: number;
}

export interface FindAccountToCreateEmployeeQuery {
  page: number;
  take: number;
  order?: any;
  phoneNumber: string;
}
